/**
 * Here are common methods for project categories handling.
 * allCategories data take the value of the category list of the current project.
 */

// store & utils
import { store } from '@/store';
import { removeAttributeTree } from '@/shared/utils';
import { getBudgetHierarchicalCategoryJson } from '@/cruds/budget.crud';

export default {
	name: 'commonCategoriesMixin',
	data: () => ({
		allCategories: []
	}),
	methods: {
		/**
		 * Get all project categories
		 * @param {Object} initCategory when no category set inside the project.
		 * @param {Number} defaultFormType default type of the expenses
		 */
		async getCategories(initCategory, defaultFormType) {
			this.allCategories = [];

			const traverseTreeAndUpdate = async (nodes, isSum) => {
				nodes.forEach((node) => {
					if (node.data.isSum === isSum && !node.children) {
						node.isDisabled = true;
					}
					if (node.children) {
						traverseTreeAndUpdate(node.children, isSum);
					}
				});
				return nodes;
			};

			// check if user can view budget global to set use app choice parameters to true or false.
			let setUseAppChoice = !store.canViewGlobalBudget() && !store.canEditExpense();

			// check if defaultFormType === 0 or 1 then get all budget category according to expense type
			if (defaultFormType === 0 || defaultFormType === 1) {
				const result = await getBudgetHierarchicalCategoryJson(-2, true, 0, -1, setUseAppChoice);

				this.allCategories = removeAttributeTree(result, 'children', null);
			}
			// else if defaultFormType === 2 then get all budget category according to that
			else if (defaultFormType === 2) {
				const result = await getBudgetHierarchicalCategoryJson(-2, true, 0, 4, setUseAppChoice);

				const resultUpdadted = await traverseTreeAndUpdate(result, true);

				this.allCategories = removeAttributeTree(resultUpdadted, 'children', null);
			}
			// if get no results
			if (this.allCategories.length === 0) {
				this.allCategories.unshift(initCategory);
			} else {
				// Deduplicate UNDEFINED-UNDEFINED categories
				const uniqueEntries = new Set();
				const deduplicated = this.allCategories.filter((obj) => {
					const key = JSON.stringify(obj);
					if (uniqueEntries.has(key)) return false;
					uniqueEntries.add(key);
					return true;
				});
				this.allCategories = deduplicated;
			}
		}
	}
};
